module.exports = __webpack_public_path__ + "static/6-0f23a49e7e360ae89c83ab8b08c6c89c.jpg";